import {
  SEND_STATUS,
  SEND_STATUS_SUCCESS
} from "./actionTypes";

export const sendStatus = (data) => {
  return {
    type: SEND_STATUS,
    payload: { data }
  }
}

export const sendStatusSuccess = (data) => {
  return {
    type: SEND_STATUS_SUCCESS,
    payload: { data }
  }
}

